/**
 * Error Reporting Service
 * Centralized error logging and reporting
 *
 * Future integration: Sentry, LogRocket, or custom backend
 */

/**
 * Log error to console and external service
 * @param {Error} error - The error object
 * @param {Object} errorInfo - React error info with component stack
 * @param {Object} context - Additional context (user, route, etc.)
 */
export const logError = (error, errorInfo, context = {}) => {
  // Console logging for development
  console.error('Error Report:', {
    error: error.toString(),
    stack: error.stack,
    componentStack: errorInfo?.componentStack,
    timestamp: new Date().toISOString(),
    context,
  });

  // TODO: Send to external error tracking service
  // Example for Sentry:
  // if (window.Sentry) {
  //   window.Sentry.captureException(error, {
  //     contexts: {
  //       react: {
  //         componentStack: errorInfo?.componentStack,
  //       },
  //     },
  //     extra: context,
  //   });
  // }

  // Example for custom backend:
  // try {
  //   await axios.post(`${window.AppConfig.serverDomain}/api/errors`, {
  //     error: error.toString(),
  //     stack: error.stack,
  //     componentStack: errorInfo?.componentStack,
  //     timestamp: new Date().toISOString(),
  //     userAgent: navigator.userAgent,
  //     url: window.location.href,
  //     ...context,
  //   });
  // } catch (reportingError) {
  //   console.error('Failed to report error:', reportingError);
  // }
};

/**
 * Log warning to console and external service
 * @param {string} message - Warning message
 * @param {Object} context - Additional context
 */
export const logWarning = (message, context = {}) => {
  console.warn('Warning:', message, context);

  // TODO: Send warnings to external service if needed
};

/**
 * Log info message
 * @param {string} message - Info message
 * @param {Object} context - Additional context
 */
export const logInfo = (message, context = {}) => {
  console.log('Info:', message, context);
};

export default {
  logError,
  logWarning,
  logInfo,
};
